import { render, staticRenderFns } from "./ServerOrderConfirmList.vue?vue&type=template&id=8cc0212c&scoped=true"
import script from "./ServerOrderConfirmList.vue?vue&type=script&lang=js"
export * from "./ServerOrderConfirmList.vue?vue&type=script&lang=js"
import style0 from "./ServerOrderConfirmList.vue?vue&type=style&index=0&id=8cc0212c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc0212c",
  null
  
)

export default component.exports